<template>
  <div class="pb-90">
    <div class="chooseBike">
      <div class="wrapper">
        <div class="grid">

          <div class="col x-6">
            <div class="sticky-wrap">
              <a :href="referer" class="backBtn">
                <svg
                  fill="none"
                  height="12"
                  viewBox="0 0 8 12"
                  width="8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 11.4531L6 6.45313L1 1.45312"
                    stroke="black"
                    stroke-width="1.5"
                  />
                </svg>
                {{ trans.back }}
              </a>

              <slider :full="true" :zoom-models="zoomModels"/>
            </div>
          </div>

          <div class="col x-6">
            <selector v-if="preselect" :trans="translates"/>

            <div class="chooseBike-text p-0">
              <div class="contacts__form-checkbox">
                <input
                  id="styled-checkbox"
                  class="inp-group__checkbox"
                  v-model="vatConfirm"
                  type="checkbox"
                >
                <label for="styled-checkbox">
                  <span class="checkbox"></span>
                  <span>I have read and acknowledge the information indicated below.</span>
                </label>
              </div>
              <p class="light-gray m-0">The prices shown include VAT.</p>
              <p class="light-gray m-0">For customers outside the EU, VAT will not be charged. These customers must make
                sure they entered the correct address during the checkout process to ensure a VAT free price.</p>
              <p class="light-gray m-0">IMPORTANT! The goods may however be assessed for import or customs fees,
                depending on the laws of each particular country, which will have to be paid by the customer.</p>
              <p class="light-gray mt-1">*Direct shipping is available to countries in Europe (continent). For rest of
                countries, please contact us at <a href="mailto:contact@forestal.com">contact@forestal.com</a>. Due to
                the extraordinary conditions with supply chain of third-party components, the displayed dates are
                subject to change.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <param-delivery-mobile v-if="false" :model="selectedModel" :trans="translates"/>

    <included-in-delivery :trans="translates" v-if="showIncluded"/>

    <div v-if="build" id="geometry-table" class="tabsBox">
      <div class="wrapper">
        <ul class="nav-tabs">
          <li class="nav-item">
            <a
              :class="tabsActiveClass('geometry_table')"
              class="nav-link"
              @click.prevent="selectTab('geometry_table')"
            >
              {{ trans['geometry_table_tab'] }}
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="tabsActiveClass('specification')"
              class="nav-link"
              @click.prevent="selectTab('specification')"
            >
              {{ trans['specification_tab'] }}
            </a>
          </li>
        </ul>

        <div class="tabs">
          <div
            v-if="isTabActive('geometry_table') && selectedModel"
            class="tab"
          >
            <geometry-table :trans="translates" :model="modelSlug"/>
          </div>
          <div
            v-if="isTabActive('specification')"
            class="tab"
          >
            <spec-table/>
          </div>
        </div>
      </div>
    </div>

    <div class="modalPrimary modal-sm custom-primary-modal" :class="{active: localPriceEnabled}">
      <div class="modalBox text-center">
        <p class="text-lg">
          <span>
            Dear Customer, Please note that the prices displayed on the website are for Spain. You will see the final price during the checkout process.
          </span>
        </p>

        <div class="btn-modal-group">
          <button type="button" class="btn btn-green btn-sm w-100" @click.prevent="hidePriceModal">
            Ok, I understand
          </button>
        </div>
      </div>
    </div>

    <div class="modalPrimary modal-sm custom-primary-modal" :class="{active: emailNotActivated}">
      <div class="modalBox text-center">
        <p class="text-lg">
          <span>
            Dear Customer, Please activate your email before start checkout.
          </span>
        </p>

        <div class="btn-modal-group">
          <button type="button" class="btn btn-green btn-sm w-100" @click.prevent="hideActivateEmailInfoModal">
            Ok
          </button>
        </div>
      </div>
    </div>

    <info-footer :trans="translates"/>
  </div>
</template>

<script>
import ModelsCarousel from './parts/ModelsCarousel'
import CarouselSyncing from './parts/BuildCarouselSync'
import GeometryTable from './parts/GeometryTable'
import SpecTable from './parts/SpecsTable'
import ParamDeliveryMobile from './parts/DeliveryParameters'
import IncludedInDelivery from "./parts/IncludedInDelivery";
import ExtraOptions from "./parts/ExtraOptions";
import Selector from "./parts/Selector";
import InfoFooter from "./parts/InfoFooter";
import {mapGetters} from "vuex";

export default {
  name: 'Choose',
  props: [
    'preselected',
    'referer',
    'trans'
  ],
  components: {
    'model-slider': ModelsCarousel,
    "sync-carousel": CarouselSyncing,
    "included-in-delivery": IncludedInDelivery,
    'geometry-table': GeometryTable,
    'spec-table': SpecTable,
    'param-delivery-mobile': ParamDeliveryMobile,
    'extra-options': ExtraOptions,
    selector: Selector,
    'slider': CarouselSyncing,
    'info-footer': InfoFooter,
  },
  computed: {
    ...mapGetters({
      steps: 'build/stepList',
      titles: 'build/titleList',
      preselect: 'build/preselected'
    }),
    translates() {
      return this.trans.text['choose']
    },
    build() {
      return this.preselect?.build || null
    },
    selectedModel() {
      return this.preselect?.model?.selected || null
    },
    modelSlug() {
      if (this.selectedModel) {
        let slug = this.selectedModel.slug;
        if (slug === 'hydra' || slug === 'e-hydra') {
          let titles = ['Halo', 'Diode'];
          return slug + titles[Math.floor(Math.random() * titles.length)]
        }

        slug = slug.replace("e-", "")

        if (this.selectedModel.slug === 'cygnus' || this.selectedModel.slug === 'siryon') {
          slug += ".muscular"
        }

        console.log("Model Slug", slug)

        return slug
      }

      return null
    },
    showIncluded() {
      return !!this.build && this.build['included_in_delivery'] && this.build['included_in_delivery'].length > 0
    },
  },
  data() {
    return {
      localPriceEnabled: true,
      emailNotActivated: false,
      selectedPaymentType: 'full',
      loading: false,
      extraOptionsVisibility: false,
      activeTab: 'geometry_table',
      isCsm: false,
      vatConfirm: false,
      zoomModels: []
    }
  },
  mounted() {
    this.$store.dispatch('build/gallery').then(response => {
      this.zoomModels = [...response]
    })

    this.$root.$on("showNotActivatedModal", () => {
      this.emailNotActivated = true
    })

    this.$root.$on('onScrollToGeometry', () => {
      this.selectTab('geometry_table')
    })

    this.$store.commit('build/setPreselected', this.preselected)

    this.addBodyPadding()
  },
  methods: {
    checkActivated() {
      return new Promise((resolve) => {
        this.$store.dispatch('checkout/checkActivated').then(response => {
          resolve(response.data.data.status)
        }).catch(err => {
          console.log("Error checking user activating", err)
          resolve(false)
        })
      })
    },
    hidePriceModal() {
      this.localPriceEnabled = false
    },
    hideActivateEmailInfoModal() {
      this.emailNotActivated = false

      let a = document.createElement('a')
      a.href = "/en/profile"
      a.target = "_blank"

      a.click()

      setTimeout(() => {
        a.remove()
      }, 20)
    },
    selectTab(type) {
      this.activeTab = type
    },
    isTabActive(type) {
      return this.activeTab === type
    },
    tabsActiveClass(type) {
      return {
        active: this.isTabActive(type)
      }
    },
    addBodyPadding() {
      let infoFooter = document.getElementsByClassName('resultFixLine')[0]
      document.getElementsByTagName("body")[0].style.paddingBottom = infoFooter.getBoundingClientRect().height + 'px'
    }
  },
  watch: {
    vatConfirm(value) {
      this.$store.commit('build/setVatConfirm', value)
    }
  },
  destroyed() {
    this.$store.commit('build/resetSelectedBuild')
  }
}
</script>

<style lang="scss">
:focus {
  outline: none;
}

.chooseBike {
  padding-top: 16px;

  .tabs {
    margin-bottom: 0;
  }

  .backBtn {
    margin: 0 -12px 24px;
    padding: 10px 12px;
    position: relative;
  }

  .btn-arr {
    font-size: 12px;
  }

  .grid {
    display: grid;
    grid-gap: 20px;
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    padding-bottom: 0;
    margin-bottom: 98px;

    .col {
      &.x-5 {
        grid-column: span 5;
      }

      &.x-7 {
        grid-column: span 7;
      }

      &.x-6 {
        grid-column: span 6;
      }
    }
  }

  .sticky-wrap {
    position: sticky;
    top: 96px;

    .sticky-wrap {
      position: relative;
      top: 0;
    }
  }

  .d-flex {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    position: relative;
  }

  .title-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 24px;
    margin: 0;

    .fs-36 {
      margin: 0 16px 0 0;
      font-size: 24px;
      line-height: 1.5;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }

  .chooseItem {
    .wrap {
      padding-bottom: 32px;
      margin-bottom: 32px;
      border-bottom: 1px solid #e3e3e3;
    }

    &:last-child {
      margin-bottom: 32px;
    }

    .btn.btn-green {
      height: 44px;
      width: 100%;
    }

    .btn-arr {
      padding: 0;
    }
  }

  .checkbox-list {
    display: grid;
    grid-gap: 16px;
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    list-style: none;
    margin: 0;
    padding: 0 0 16px;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }

    li {
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      background: #ffffff;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      border-radius: 16px;
      padding: 22px 35px;
      margin-bottom: 0;
      overflow: hidden;
      position: relative;
      transition: 0.4s;
      min-height: 68px;

      .ui-tooltip{
        position: absolute;
        top: 16px;
        right: 14px;
        z-index: 2;

        @media (max-width: 991px) {
          top: 18px;
          right: 10px;
          .ui-tooltip__btn{
            width: 12px;
            height: 12px;
          }
        }
      }
      &:hover{
        overflow: initial;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &.moto-style {
        border: none;
        padding: 0;
      }

      .stripe{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 16px;
        height: calc(100% + 2px);
        overflow: hidden;
        opacity: 0;
        border-radius: 16px 0 0 16px;
        z-index: 1;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 8px;
          height: 100%;
          background-color: #c2e900;
          transition: 0s;

        }
      }

      &.active {
        background: #f8f8f8;

        .stripe {
          opacity: 1;
        }
      }

      .title {
        font-weight: 500;
        font-size: 17px;
        line-height: 1;
        margin: 0 0 10px;
        color: #474747;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;

        &.w-100 {
          width: 100%;
        }

        .fs-12 {
          color: rgba(0, 0, 0, 0.3);
          line-height: 1;
          margin-left: 18px;
          padding-left: 19px;
          border-left: 1px solid rgba(0, 0, 0, 0.3);
          display: inline-block;
          vertical-align: middle;
        }
      }

      .price {
        font-size: 12px;
        line-height: 1.1;
        color: rgba(0, 0, 0, 0.3);
        margin: -22px 0 0 auto;
        text-align: right;

        max-width: 130px;

        .mt-2\.5{
          margin-top: 10px;
        }

        span {
          display: block;
          color: #474747;
          font-size: 17px;
          margin: 10px 0 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
          &.mt-0{
            margin-top: 0;
          }
          &.mr-1{
            margin-right: 4px;
          }
        }
      }

      .description {
        font-size: 12px;
        line-height: 17px;
        color: #474747;
        margin: 0 0;
        max-width: calc(100% - 130px);
        padding-right: 12px;

        p {
          margin: 0 0;
        }
      }

      .cost {
        color: #474747;
        font-size: 17px;
        margin: 0 0 10px auto;
        white-space: nowrap;
        //overflow: hidden;
        text-overflow: ellipsis;
        max-width: 130px;
        display: flex;
        align-items: center;
      }

      .buildBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .group {
          margin: 10px 40px 0 0;
          display: flex;
          flex-direction: row-reverse;

          &:last-child {
            margin-right: 0;
          }

          .buildBox__img {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            img {
              width: 17px;
              height: 17px;
              object-fit: contain;
              margin: 2px 8px 2px 0;
              border-radius: 100%;

              &:last-child {
                margin-right: 0;
              }
            }
          }

          .buildBox__text {
            font-size: 12px;
            line-height: 17px;
            color: #a3a3a3;
            margin: 2px 8px 2px 0;
          }
        }
      }

      .titleSize,
      .titleOption {
        margin: 0 0 10px;
        font-weight: 500;
        font-size: 17px;
        line-height: 17px;
        width: 100%;
      }

      .textSize,
      .textOption {
        margin: 0 0 0;
        font-size: 12px;
        line-height: 17px;
        width: 100%;
        max-width: 140px;
      }

      .noneText {
        position: absolute;
        margin: auto;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 14px;
      }

      .imgOption {
        position: absolute;
        width: 48px;
        height: 48px;
        left: 12px;
        top: 0;
        bottom: 0;
        margin: auto;
        mix-blend-mode: darken;
      }

      .nameOption {
        margin: 8px 0 8px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        width: 100%;
      }

      .priceOption {
        font-weight: bold;
        font-size: 17px;
        line-height: 18px;
        margin: 0 0 5px;
        width: 100%;
      }
    }

    &.color-wrap {
      display: grid;
      grid-gap: 16px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);

      li {
        padding: 20px 15px 20px 72px;
        margin: 0;

        .icColor {
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 34px;
          height: 34px;
          object-fit: contain;
          border-radius: 100%;
        }

        .nameColor {
          font-size: 17px;
          line-height: 1.2;
          color: #474747;
          margin: 0 0 10px;
          width: 100%;
          font-weight: 500;

          &:last-child {
            margin-bottom: 0;
            align-self: center;
          }
        }

        .textColor {
          font-size: 12px;
          line-height: 1;
          margin: 0;
        }
      }
    }

    &.size-wrap {
      display: grid;
      grid-gap: 20px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      padding-bottom: 16px;

      li {
        margin: 0;
      }
    }

    &.option-wrap {
      display: grid;
      grid-gap: 20px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      padding-bottom: 20px;

      li {
        margin: 0;
      }
    }

    &.pedal-wrap {
      display: grid;
      grid-gap: 20px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      padding-bottom: 20px;

      li {
        margin: 0;
        padding-left: 72px;
        padding-right: 15px;
      }
    }

    & ~ .fs-11.color-gray.mb-40 {
      margin-top: 0;
      margin-bottom: 16px !important;
    }
  }

  .groupColor {
    margin: 0;
    padding-bottom: 32px;

    .color-title {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 0 0 16px;
      margin: 0;
    }

    .fs-24 {
      margin: 0 0 0;
      color: #000;
      font-size: 17px;
      line-height: 17px;

      &.medium {
        padding-right: 16px;
      }
    }
  }

  .customColor {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;

    .fs-24 {
      margin: 0 0 24px;
      color: #000;
    }

    .btn-color {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 13px;
      line-height: 2;
      height: 44px;
      padding: 0 12px;
      border: none;
      transition: 0.4s;
      background-image: linear-gradient(
          90deg,
          #ffd600 0%,
          #ff0000 27.26%,
          #5200ff 66.32%,
          #de5cff 100%
      );
      position: relative;
      z-index: 1;
      margin-bottom: 16px;
      border-radius: 7px;

      svg {
        filter: grayscale(100%);
      }

      span {
        transition: 0.4s;
      }

      &:before {
        content: '';
        transition: 0.4s;
        background-color: #fff;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        position: absolute;
        z-index: -1;
        border-radius: 5px;
      }

      svg {
        margin: -2px 18px 0 0;
        width: 20px;
        height: 20px;
      }

      &:hover {
        span {
          background: -webkit-linear-gradient(0deg, #d5003e 0%, #6800de 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        svg {
          filter: grayscale(0%);
        }
      }

      &.active {
        &:before {
          opacity: 0.9;
        }

        span {
          background: transparent;
          -webkit-background-clip: inherit;
          -webkit-text-fill-color: inherit;
        }

        svg {
          filter: grayscale(100%);
        }
      }
    }

    .fs-11 {
      line-height: 16px;
      margin: 0 0 16px;
    }
  }

  .groupOptions {
    margin-bottom: 32px;

    .fs-24 {
      font-size: 17px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    .option-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .fs-24 {
        margin: 0;
        color: #000;

        &.medium {
          padding-right: 16px;
        }
      }
    }
  }

  .paymentOptions {
    margin-bottom: 16px;
    padding-top: 32px;

    .fs-24 {
      margin: 0 0 24px;
    }

    .fs-36 {
      font-size: 24px;
      margin-bottom: 24px;
      margin-top: 0;
    }

    .checkboxLg {
      position: relative;
      border: 1px solid #e3e3e3;
      border-bottom: none;
      margin-bottom: 0;
      padding: 24px 32px;
      color: #232323;
      overflow: hidden;
      cursor: pointer;

      &:first-of-type {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }

      &:last-of-type {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        border-bottom: 1px solid #e3e3e3;
      }

      &.active {
        background-color: #F8F8F8;

        &:before {
          opacity: 1;
        }
      }

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 8px;
        height: 100%;
        background-color: #c2e900;
        transition: 0s;
        opacity: 0;
      }

      .fs-24 {
        color: #000;
        margin: 0 0 12px;
        font-size: 17px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .d-flex {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .fs-17 {
        line-height: 26px;
        margin: 0;
        display: block;

        &:nth-child(2) {
          text-align: right;
        }

        .d-block {
          display: block;
          margin-bottom: 4px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .fs-12 {
        &:nth-child(2) {
          text-align: right;
          max-width: 50%;
          line-height: 18px;
        }
      }

      hr {
        background-color: #e3e3e3;
        height: 1px;
        border: none;
        margin: 30px 0;
        width: 100%;
      }

      .fs-11 {
        line-height: 16px;
        margin: 0;
      }
    }
  }

  .nav-mobile-tabs {
    display: none;
  }

  .chooseBike-text {
    p {
      color: #A3A3A3;
      font-size: 11px;
      line-height: 16px;
      margin: 0 0 6px;
      display: block;
      padding-left: 39px;
    }


    @media (min-width: 768px) {
      padding: 0 33px;
      &.p-0 {
        padding: 0;
      }
    }
  }

  @media (max-width: 1300px) {
    .grid {
      grid-gap: 20px;
    }
  }
  @media (max-width: 991px) {
    padding-top: 32px;
    .grid {
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 40px;
      margin-bottom: 80px;

      .col.x-5 {
        grid-column: span 1;
      }

      .col.x-7 {
        grid-column: span 1;
      }

      .col.x-6 {
        grid-column: span 1;
      }
    }
    .backBtn {
      display: none;
    }
    .sticky-wrap {
      max-width: 610px;
      margin: 0 auto;
    }
    .chooseItem {
      .fs-11.mb-40 {
        margin-bottom: 10px !important;
      }
    }
    .checkbox-list {
      padding-bottom: 20px;
      grid-gap: 16px;

      li {
        padding: 22px 25px;
        margin-bottom: 0;

        .title {
          .fs-12 {
            margin-left: 8px;
            padding-left: 8px;
          }
        }
      }

      &.color-wrap,
      &.size-wrap,
      &.option-wrap,
      &.pedal-wrap {
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 16px;
      }
    }
    .customColor {
      .fs-11 {
        line-height: 16px;
      }
    }
    .groupOptions {
      .checkbox-list li {
        min-height: 80px;
      }
    }
  }
  @media (max-width: 767px) {
    .sticky-wrap {
      position: relative;
      top: 0;
    }
    .grid {
      grid-gap: 0;
      display: block;

      &:last-child {
        border-bottom: none;
        padding-bottom: 140px;
        margin-bottom: 0;
      }
    }
    .col.x-6:first-of-type {
      margin-bottom: 66px;
    }
    .title-wrap {
      flex-wrap: wrap;

      .fs-36 {
        max-width: calc(100% - 76px);
        width: 100%;
        margin-right: 0;
      }

      .btn.btn-arr {
        margin: 10px 0 0;
      }
    }
    .checkbox-list {
      li {
        .title {
          font-size: 14px;
          order: 1;
          width: auto;
          max-width: 50%;
          margin-bottom: 18px;

          .fs-12 {
            display: block;
            padding-left: 0;
            margin: 6px 0 0;
            border: none;
            width: 100%;
          }
        }

        .price {
          font-size: 14px;
          margin: 0 0 18px auto;
          order: 2;
          max-width: 50%;
          white-space: nowrap;
          //overflow: hidden;
          text-overflow: ellipsis;

          span {
            font-size: 14px;
            margin: 0;
            display: inline;
          }
        }

        .description {
          width: 100%;
          max-width: 100%;
          order: 3;
        }

        .cost {
          order: 2;
          font-size: 14px;
          margin-bottom: 18px;
        }

        .buildBox {
          order: 3;
          margin-top: -16px;
          margin-right: -24px;
          width: auto;

          .group {
            margin: 12px 26px 0 0;

            .buildBox__text {
              margin: 6px 6px 6px 0;
            }
          }
        }

        .titleSize,
        .titleOption {
          margin: 0 0 14px;
          font-size: 14px;
          line-height: 1;
        }

        .nameOption {
          margin: 0 0 20px;
          font-size: 14px;
          line-height: 1;
        }

        .imgOption {
          width: 65px;
          height: 70px;
          left: 25px;
        }
      }

      &.pedal-wrap {
        padding-bottom: 32px;

        li {
          padding-left: 125px;
        }
      }
    }
    .customColor {
      .fs-24 {
        font-size: 17px;
        line-height: 1;
        margin-bottom: 16px;
      }
    }
    .groupOptions {
      margin-bottom: 28px;

      .option-title {
        margin-bottom: 16px;

        &.mb-40 {
          margin-bottom: 16px !important;
        }
      }
    }
    .paymentOptions {
      .checkboxLg {
        .d-flex {
        }

        .fs-17 {
          font-size: 12px;
          line-height: 1.6;

          .d-block {
            margin-bottom: 8px;
          }
        }
      }
    }
    .fs-24 {
      font-size: 17px;
      line-height: 1;
    }
    .nav-mobile-tabs {
      display: flex;
      padding-bottom: 12px;
      margin-bottom: 24px;
      overflow: scroll;
      width: 100vw;
      max-width: 100vw;
      padding-left: 24px;
      margin-left: -24px;
      margin-right: 0;

      .nav-item {
        margin-right: 18px;

        .nav-link {
          white-space: nowrap;
          font-size: 17px;
          line-height: 25px;
          color: #000;
          text-decoration: none;
          position: relative;
          display: inline-block;

          &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 4px;
            top: calc(100% + 2px);
            left: 2px;
            background-color: transparent;
            border-radius: 24px;
          }

          &.active {
            font-weight: bold;

            span {
              font-weight: normal;
            }

            &:before {
              background-color: #c2e900;
            }
          }
        }

        &:last-child {
          padding-right: 24px;
        }
      }
    }
    .tabs {
      margin-bottom: 32px;

      .color-title {
        display: none;
      }

      .groupColor {
        display: none;
        margin-bottom: 0;
        padding-bottom: 0;

        &.show {
          display: block;
        }
      }
    }


  }
  @media (max-width: 575px) {
    .title-wrap .fs-36 {
      font-size: 20px;
    }
  }
}

.tabsBox {
  margin-bottom: 105px;

  .nav-tabs {
    padding: 0;
    margin: 0 0 32px;
    display: flex;
    align-items: flex-start;

    .nav-item {
      margin-right: 80px;

      &:last-child {
        margin-right: 0;
      }

      .nav-link {
        display: inline-block;
        font-weight: normal;
        font-size: 24px;
        line-height: 1;
        color: #000000;
        position: relative;
        padding: 0 0 24px 0;
        text-decoration: none;
        cursor: pointer;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 4px;
          background: #c2e900;
          border-radius: 24px;
          opacity: 0;
        }

        &.active {
          font-weight: bold;
          cursor: default;

          &:before {
            opacity: 1;
          }
        }
      }
    }
  }

  .tabs {
    .tab {
    }
  }

  @media (max-width: 991px) {
    .nav-tabs {
      .nav-item {
        margin-right: 44px;

        .nav-link {
          font-size: 20px;
          padding: 0 0 12px 0;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .nav-tabs {
      margin-bottom: 40px;
    }
  }
  @media (max-width: 575px) {
    .nav-tabs {
      justify-content: flex-start;
      width: calc(100% + 40px);
      margin-left: -20px;
      overflow: auto;
      padding-left: 20px;
      padding-right: 20px;

      .nav-item {
        margin-right: 20px;

        .nav-link {
          font-size: 20px;
          line-height: 128%;
          padding: 0 0 8px 0;
          white-space: nowrap;
        }
      }
    }
  }

}

.resultFixLine {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 2000;
  border-top: 1px solid #e3e3e3;
  padding: 5px 0;

  .flex {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .wrapper-l {
    width: 44%;
    display: flex;
    align-items: center;
  }

  .wrapper-r {
    width: 56%;
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .text-wrap {
    display: flex;
    align-items: center;
    max-width: 178px;
    padding-right: 4px;

    &:first-child {
      width: 288px;
      max-width: 288px;
    }

    img {
      width: 26px;
      min-width: 26px;
      height: 26px;
      margin-right: 24px;
    }

    .fs-14 {
      line-height: 17px;
      color: #474747;
      margin: 0;
      font-size: 10px;

      strong {
        display: block;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .totalText {
    text-align: right;
    margin: 0 12px 0 0;
    width: auto;
    padding: 0;
    .total-text-wrap{
      margin: 0 0 4px;
      &:last-child {
        margin: 0;
      }
    }
    .fs-24 {
      line-height: 1;
      display: block;
      margin: 0 0 6px;
      //font-weight: bold;
      color: #000000;
      width: 215px;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:last-child {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    .fs-12{
      color: rgba(0, 0, 0, 0.3);
      display: block;
      line-height: 1;
    }

    .btn.btn-arr {
      padding: 0;
      background-color: transparent !important;

      .hide {
        display: none;
      }

      &.disabled {
        opacity: 0.3;
      }


      .span-show {
        & ~ svg {
          transform: rotate(90deg);
        }
      }

      .span-hide {
        opacity: 0.3;

        & ~ svg {
          transform: rotate(-90deg);
        }
      }
    }
  }

  .btn.btn-green {
    width: 277px;
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    cursor: pointer;
    padding-top: 2px;

    &[disabled] {
      cursor: default;
    }
  }

  .extraOption {
    width: 100%;
    padding: 14px 0 8px;
    margin-top: 24px;
    border-top: 1px solid #e3e3e3;
    flex-wrap: wrap;
    align-items: center;
    display: flex;

    li {
      margin-right: 40px;
      font-weight: 500;
      line-height: 1;
      padding: 4px 0;

      .price {
        margin-left: 12px;
      }
    }
  }

  .stepLine {
    margin: 0 auto;

    .text {
      margin: 0 0 12px;
      font-weight: 500;
      line-height: 1;
      color: #474747;
      font-size: 10px;
      text-align: center;
    }

    ul {
      width: 108px;
      z-index: 1;
      padding: 0;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:before {
        content: '';
        position: absolute;
        height: 1px;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: #e3e3e3;
        z-index: -1;
      }

      li {
        width: 8px;
        height: 8px;
        background-color: #fff;
        border: 1px solid #e3e3e3;
        border-radius: 100%;
        z-index: 4;
      }

      &.step-1 {
        li {
          &:nth-child(1) {
            background-color: #c2e900;
            border-color: #c2e900;

            &:after {
              content: '';
              position: absolute;
              height: 1px;
              width: 25%;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #c2e900;
              z-index: 1;
            }
          }
        }
      }

      &.step-2 {
        li {
          &:nth-child(1) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(2) {
            background-color: #c2e900;
            border-color: #c2e900;

            &:after {
              content: '';
              position: absolute;
              height: 1px;
              width: 50%;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #c2e900;
              z-index: 1;
            }
          }
        }
      }

      &.step-3 {
        li {
          &:nth-child(1) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(2) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(3) {
            background-color: #c2e900;
            border-color: #c2e900;

            &:after {
              content: '';
              position: absolute;
              height: 1px;
              width: 75%;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #c2e900;
              z-index: 1;
            }
          }
        }
      }

      &.step-4 {
        li {
          &:nth-child(1) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(2) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(3) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(4) {
            background-color: #c2e900;
            border-color: #c2e900;

            &:after {
              content: '';
              position: absolute;
              height: 1px;
              width: 100%;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #c2e900;
              z-index: 1;
            }
          }
        }
      }

      &.step-5 {
        li {
          &:nth-child(1) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(2) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(3) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(4) {
            background-color: #c2e900;
            border-color: #c2e900;
          }

          &:nth-child(5) {
            background-color: #c2e900;
            border-color: #c2e900;

            &:after {
              content: '';
              position: absolute;
              height: 1px;
              width: 100%;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #c2e900;
              z-index: 1;
            }
          }
        }
      }
    }
  }

  .side-enter-active, .side-leave-active {
    max-height: 95px;
    transition: all .5s ease-in-out;
  }

  .side-enter, .side-leave-to {
    max-height: 0;
    opacity: 0;
    padding: 0;
    margin: 0;
  }


  //@media (min-width: 768px) {
  //  .btn-green {
  //    height: 46px;
  //  }
  //}

  @media (max-width: 1300px) {
    .text-wrap:first-child {
      width: 244px;
      max-width: 244px;
    }
    .btn.btn-green {
      width: 255px;
    }
    .totalText .fs-24 {
      width: 180px;
      font-size: 20px;
    }
  }
  @media (max-width: 991px) {
    .wrapper-r {
      width: 100%;
      flex-wrap: wrap;
    }
    .wrapper-l {
      display: none;
    }
    .text-wrap {
      display: none;
    }
    .stepLine {
      margin: 0;

      ul {
        width: 218px;
      }
    }
    .totalText {
      text-align: center;
      margin: 0 auto;
    }
    .btn.btn-green {
      width: 218px;
    }
    .extraOption {
      padding: 16px 0 4px;
      margin-top: 16px;
    }
  }
  @media (max-width: 767px) {
    padding: 12px 0 20px;
    .stepLine {
      width: 100%;
      margin: 0 0 14px;

      .text {
        display: none;
      }

      ul {
        width: 100%;
      }
    }
    .totalText {
      margin: 0 0 0 auto;
      text-align: right;
      width: calc(100% - 157px);
      padding-right: 16px;

      .btn-arr svg {
        margin-left: 8px;
      }

      .fs-24 {
        margin-left: auto;
      }
    }
    .btn.btn-green {
      width: 157px;
      height: 42px;
    }
  }
  @media (max-width: 575px) {
    .extraOption {
      padding: 8px 0 8px;
      max-height: 129px;
      overflow: auto;

      li {
        width: 100%;
        margin-right: 0;
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
      }
    }
  }
  @media (max-width: 360px) {
    .totalText {
      margin: 0 0 0 auto;
      text-align: right;
      width: calc(100% - 100px);
      padding-right: 16px;

      .btn-arr svg {
        margin-left: 8px;
      }
    }
    .btn.btn-green {
      width: 100px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
}

.chooseBike-text {
  .contacts__form-checkbox {
    margin-bottom: 2px !important;
  }

  .m-0 {
    margin: 0 !important;
  }

  .mt-1 {
    margin-top: 15px !important;
  }
}

</style>
